import type { ReactElement } from "react";

import { ComboboxWithSelectAll } from "app/pages/sales-intelligence/common-components/dropdown/ComboboxWithSelectAll";
import { FormFieldLabel } from "app/pages/sales-intelligence/common-components/form-fields";
import type { CrmField } from "app/pages/sales-intelligence/domain/leads/types/filter-options";

import type { ICrmFieldsSelectProps } from "./types";
import { createDropdownItems, getSelectAllLabel } from "./utils";

const CrmFieldsSelect = ({
    fields,
    fieldLabels,
    onSelectionChange,
    getSelectedValues,
    disabled = false,
}: ICrmFieldsSelectProps): ReactElement => {
    const renderField = (field: CrmField) => {
        const selectedItems = getSelectedValues(field.fieldName);
        const items = createDropdownItems(field);
        const labels = fieldLabels[field.fieldName];

        return (
            <FormFieldLabel
                key={field.fieldName}
                text={labels.label}
            >
                <ComboboxWithSelectAll
                    onSelectionChange={(selection, isAllSelected: boolean) =>
                        onSelectionChange(field.fieldName, selection, isAllSelected)
                    }
                    selectedItems={selectedItems}
                    items={items}
                    buttonText={labels.placeholder}
                    hasSearch
                    searchPlaceHolder={labels.placeholder}
                    selectAllLabel={getSelectAllLabel()}
                    disabled={disabled}
                />
            </FormFieldLabel>
        );
    };

    return <>{fields.map(renderField)}</>;
};

export default CrmFieldsSelect;
